import React from 'react'
import "./jobs.css"

function Jobs() {
  return (
    <div>Jobs</div>
  )
}

export default Jobs